import { combineReducers } from 'redux';
import page from './Page';
import hexCode from './HexCode';

export default combineReducers({
  page,
  hexCode
});